// src/config/firebase.ts
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBnSM3n6QdmqrEoKZitCCs7c5Eo-AjOEYU",
  authDomain: "laplage-bed59.firebaseapp.com",
  projectId: "laplage-bed59",
  storageBucket: "laplage-bed59.appspot.com",
  messagingSenderId: "694682248015",
  appId: "1:694682248015:web:1ebb3106f46ca6521adb3a",
  measurementId: "G-2E7TQXDP1S",
};

// Initialize Firebase only if it hasn't been initialized already
const firebaseApp =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const auth = getAuth(firebaseApp);

export { firebaseApp, auth };
